import { render, staticRenderFns } from "./materialData.vue?vue&type=template&id=0283f30c&scoped=true&"
import script from "./materialData.vue?vue&type=script&lang=js&"
export * from "./materialData.vue?vue&type=script&lang=js&"
import style0 from "./materialData.vue?vue&type=style&index=0&id=0283f30c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0283f30c",
  null
  
)

export default component.exports